import { fetchConversation } from '@/api/instantMessaging'

const formatCoversationFromApi = coversation => {
  return {
    caseName: coversation.caseName,
    conversationId: coversation.conversationId,
    type: coversation.lastMessageType,
    lastMessage: coversation.lastMessageText,
    timestamp: coversation.timestamp,
    unread: coversation.unread,
    username: coversation.visitorName
  }
}

const state = {
  showChatBox: false,
  showFAQ: false,
  conversations: [],
  currentConversationId: null
}

export const getters = {
  showChatBox: state => state.showChatBox,
  showFAQ: state => state.showFAQ,
  conversations: state => state.conversations,
  currentConversationId: state => state.currentConversationId
}

export const actions = {
  toggleChatbox ({ commit }, bool) {
    commit('TOGGLE_SHOW_CHAT_BOX', bool)
  },
  toggleFAQ ({ commit }, bool) {
    commit('TOGGLE_SHOW_FAQ', bool)
  },
  fetchConversation ({ commit }) {
    fetchConversation()
      .then(({ conversations }) => {
        commit('SET_CONVERSATIONS', conversations)
      })
      .catch(error => {
        console.error(error)
      })
  },
  setCurrentConversationId ({ commit }, id = null) {
    commit('SET_CURRENT_CONVERSATION_ID', id)
    commit('SET_COVERSATION_READED', id)
  },
  onMessageEventHandler ({ commit }, message) {
    commit('SET_MESSAGE_DATA', message)
  }
}

export const mutations = {
  TOGGLE_SHOW_CHAT_BOX (state, bool) {
    if (bool === undefined) {
      state.showChatBox = !state.showChatBox
    } else {
      state.showChatBox = bool
    }
  },
  TOGGLE_SHOW_FAQ (state, bool) {
    if (bool === undefined) {
      state.showFAQ = !state.showFAQ
    } else {
      state.showFAQ = bool
    }
  },
  SET_CONVERSATIONS (state, conversations) {
    state.conversations = conversations.map(formatCoversationFromApi)
  },
  SET_CURRENT_CONVERSATION_ID (state, id) {
    state.currentConversationId = id
  },
  SET_COVERSATION_READED (state, id) {
    const targetConversationIndex = state.conversations.findIndex(conversation => conversation.conversationId === id)
    if (targetConversationIndex > -1) {
      const targetConversation = Object.assign({}, state.conversations[targetConversationIndex])
      targetConversation.unread = false
      state.conversations.splice(targetConversationIndex, 1, targetConversation)
    }
  },
  SET_MESSAGE_DATA (state, message) {
    const targetConversation = state.conversations.find(conversation => conversation.conversationId === message.conversation.id)
    if (targetConversation) {
      targetConversation.type = message.type
      targetConversation.lastMessage = message.body
      targetConversation.timestamp = message.timestamp
      if (!message.isByMe) {
        if (
          state.currentConversationId !== targetConversation.conversationId ||
          !state.showChatBox
        ) {
          targetConversation.unread = true
        }
      }
    } else {
      const newConversation = {
        type: message.type,
        lastMessage: message.body,
        timestamp: message.timestamp,
        conversationId: message.conversation.id,
        caseName: message.conversation.custom.caseName,
        username: message.conversation.custom.visitorName,
        unread: true
      }
      state.conversations.unshift(newConversation)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
